// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.6
//   protoc               v6.33.2
// source: api/devplan/types/comments.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { ArtifactType, artifactTypeFromJSON, artifactTypeToJSON } from "./artifacts";
import { EntityMeta } from "./common";
import { InlineComment } from "./inline_comments";

export const protobufPackage = "api.devplan.types.comments";

export enum CommentThreadStatus {
  DEFAULT_STATUS = 0,
  RESOLVED = 1,
}

export function commentThreadStatusFromJSON(object: any): CommentThreadStatus {
  switch (object) {
    case 0:
    case "DEFAULT_STATUS":
      return CommentThreadStatus.DEFAULT_STATUS;
    case 1:
    case "RESOLVED":
      return CommentThreadStatus.RESOLVED;
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum CommentThreadStatus");
  }
}

export function commentThreadStatusToJSON(object: CommentThreadStatus): string {
  switch (object) {
    case CommentThreadStatus.DEFAULT_STATUS:
      return "DEFAULT_STATUS";
    case CommentThreadStatus.RESOLVED:
      return "RESOLVED";
    default:
      throw new globalThis.Error("Unrecognized enum value " + object + " for enum CommentThreadStatus");
  }
}

export interface CommentAssociations {
  documentId?: string | undefined;
  projectId?: string | undefined;
  artifact?: ArtifactMention | undefined;
}

export interface ArtifactMention {
  id: string;
  type: ArtifactType;
}

export interface Comment {
  id: string;
  meta: EntityMeta | undefined;
  threadId: string;
  content: string;
  parentId?: string | undefined;
  companyId: number;
}

export interface CommentThread {
  id: string;
  meta: EntityMeta | undefined;
  companyId: number;
  status: CommentThreadStatus;
}

export interface ThreadWithComments {
  thread: CommentThread | undefined;
  comments: Comment[];
}

/**
 * Repository inline comments (for Research Area feedback)
 * This should capture the values in the RepoResearchCommentEntry in the DB layer,
 * except for the companyId field relation that is only needed when deleting comments as an additional safeguard.
 * Additionally, it takes the anchor-related attributes and embeds them into the InlineComment struct
 */
export interface RepoResearchComment {
  id: string;
  meta: EntityMeta | undefined;
  repoId: string;
  /**
   * Research Area the comment is associated with, e.g. "summary", "build_process"
   * or "" for feedback around the research as a whole.
   */
  area?: string | undefined;
  comment: InlineComment | undefined;
}

export interface RepoResearchCommentsGroupedCounts {
  countsByArea: { [key: string]: number };
}

export interface RepoResearchCommentsGroupedCounts_CountsByAreaEntry {
  key: string;
  value: number;
}

/**
 * RepoResearchCommentsByArea aggregates inline comments grouped by research area.
 * Map keys are research area names (e.g. "summary", "build_process").
 */
export interface RepoResearchCommentsByArea {
  commentsByArea: { [key: string]: RepoResearchCommentList };
}

export interface RepoResearchCommentsByArea_CommentsByAreaEntry {
  key: string;
  value: RepoResearchCommentList | undefined;
}

/** RepoResearchCommentList wraps a repeated list of RepoResearchComment. */
export interface RepoResearchCommentList {
  comments: RepoResearchComment[];
}

function createBaseCommentAssociations(): CommentAssociations {
  return { documentId: undefined, projectId: undefined, artifact: undefined };
}

export const CommentAssociations: MessageFns<CommentAssociations> = {
  encode(message: CommentAssociations, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.documentId !== undefined) {
      writer.uint32(10).string(message.documentId);
    }
    if (message.projectId !== undefined) {
      writer.uint32(18).string(message.projectId);
    }
    if (message.artifact !== undefined) {
      ArtifactMention.encode(message.artifact, writer.uint32(26).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CommentAssociations {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommentAssociations();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.documentId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.projectId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.artifact = ArtifactMention.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CommentAssociations {
    return {
      documentId: isSet(object.documentId)
        ? globalThis.String(object.documentId)
        : isSet(object.document_id)
        ? globalThis.String(object.document_id)
        : undefined,
      projectId: isSet(object.projectId)
        ? globalThis.String(object.projectId)
        : isSet(object.project_id)
        ? globalThis.String(object.project_id)
        : undefined,
      artifact: isSet(object.artifact) ? ArtifactMention.fromJSON(object.artifact) : undefined,
    };
  },

  toJSON(message: CommentAssociations): unknown {
    const obj: any = {};
    if (message.documentId !== undefined) {
      obj.documentId = message.documentId;
    }
    if (message.projectId !== undefined) {
      obj.projectId = message.projectId;
    }
    if (message.artifact !== undefined) {
      obj.artifact = ArtifactMention.toJSON(message.artifact);
    }
    return obj;
  },

  create(base?: DeepPartial<CommentAssociations>): CommentAssociations {
    return CommentAssociations.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CommentAssociations>): CommentAssociations {
    const message = createBaseCommentAssociations();
    message.documentId = object.documentId ?? undefined;
    message.projectId = object.projectId ?? undefined;
    message.artifact = (object.artifact !== undefined && object.artifact !== null)
      ? ArtifactMention.fromPartial(object.artifact)
      : undefined;
    return message;
  },
};

function createBaseArtifactMention(): ArtifactMention {
  return { id: "", type: 0 };
}

export const ArtifactMention: MessageFns<ArtifactMention> = {
  encode(message: ArtifactMention, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.type !== 0) {
      writer.uint32(16).int32(message.type);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ArtifactMention {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseArtifactMention();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.type = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ArtifactMention {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      type: isSet(object.type) ? artifactTypeFromJSON(object.type) : 0,
    };
  },

  toJSON(message: ArtifactMention): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.type !== 0) {
      obj.type = artifactTypeToJSON(message.type);
    }
    return obj;
  },

  create(base?: DeepPartial<ArtifactMention>): ArtifactMention {
    return ArtifactMention.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ArtifactMention>): ArtifactMention {
    const message = createBaseArtifactMention();
    message.id = object.id ?? "";
    message.type = object.type ?? 0;
    return message;
  },
};

function createBaseComment(): Comment {
  return { id: "", meta: undefined, threadId: "", content: "", parentId: undefined, companyId: 0 };
}

export const Comment: MessageFns<Comment> = {
  encode(message: Comment, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.meta !== undefined) {
      EntityMeta.encode(message.meta, writer.uint32(18).fork()).join();
    }
    if (message.threadId !== "") {
      writer.uint32(26).string(message.threadId);
    }
    if (message.content !== "") {
      writer.uint32(34).string(message.content);
    }
    if (message.parentId !== undefined) {
      writer.uint32(42).string(message.parentId);
    }
    if (message.companyId !== 0) {
      writer.uint32(48).int32(message.companyId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): Comment {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseComment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.meta = EntityMeta.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.threadId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.content = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.parentId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): Comment {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      meta: isSet(object.meta) ? EntityMeta.fromJSON(object.meta) : undefined,
      threadId: isSet(object.threadId)
        ? globalThis.String(object.threadId)
        : isSet(object.thread_id)
        ? globalThis.String(object.thread_id)
        : "",
      content: isSet(object.content) ? globalThis.String(object.content) : "",
      parentId: isSet(object.parentId)
        ? globalThis.String(object.parentId)
        : isSet(object.parent_id)
        ? globalThis.String(object.parent_id)
        : undefined,
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
    };
  },

  toJSON(message: Comment): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.meta !== undefined) {
      obj.meta = EntityMeta.toJSON(message.meta);
    }
    if (message.threadId !== "") {
      obj.threadId = message.threadId;
    }
    if (message.content !== "") {
      obj.content = message.content;
    }
    if (message.parentId !== undefined) {
      obj.parentId = message.parentId;
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    return obj;
  },

  create(base?: DeepPartial<Comment>): Comment {
    return Comment.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<Comment>): Comment {
    const message = createBaseComment();
    message.id = object.id ?? "";
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? EntityMeta.fromPartial(object.meta)
      : undefined;
    message.threadId = object.threadId ?? "";
    message.content = object.content ?? "";
    message.parentId = object.parentId ?? undefined;
    message.companyId = object.companyId ?? 0;
    return message;
  },
};

function createBaseCommentThread(): CommentThread {
  return { id: "", meta: undefined, companyId: 0, status: 0 };
}

export const CommentThread: MessageFns<CommentThread> = {
  encode(message: CommentThread, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.meta !== undefined) {
      EntityMeta.encode(message.meta, writer.uint32(18).fork()).join();
    }
    if (message.companyId !== 0) {
      writer.uint32(24).int32(message.companyId);
    }
    if (message.status !== 0) {
      writer.uint32(32).int32(message.status);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CommentThread {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCommentThread();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.meta = EntityMeta.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.companyId = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CommentThread {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      meta: isSet(object.meta) ? EntityMeta.fromJSON(object.meta) : undefined,
      companyId: isSet(object.companyId)
        ? globalThis.Number(object.companyId)
        : isSet(object.company_id)
        ? globalThis.Number(object.company_id)
        : 0,
      status: isSet(object.status) ? commentThreadStatusFromJSON(object.status) : 0,
    };
  },

  toJSON(message: CommentThread): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.meta !== undefined) {
      obj.meta = EntityMeta.toJSON(message.meta);
    }
    if (message.companyId !== 0) {
      obj.companyId = Math.round(message.companyId);
    }
    if (message.status !== 0) {
      obj.status = commentThreadStatusToJSON(message.status);
    }
    return obj;
  },

  create(base?: DeepPartial<CommentThread>): CommentThread {
    return CommentThread.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<CommentThread>): CommentThread {
    const message = createBaseCommentThread();
    message.id = object.id ?? "";
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? EntityMeta.fromPartial(object.meta)
      : undefined;
    message.companyId = object.companyId ?? 0;
    message.status = object.status ?? 0;
    return message;
  },
};

function createBaseThreadWithComments(): ThreadWithComments {
  return { thread: undefined, comments: [] };
}

export const ThreadWithComments: MessageFns<ThreadWithComments> = {
  encode(message: ThreadWithComments, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.thread !== undefined) {
      CommentThread.encode(message.thread, writer.uint32(10).fork()).join();
    }
    for (const v of message.comments) {
      Comment.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ThreadWithComments {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseThreadWithComments();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.thread = CommentThread.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.comments.push(Comment.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ThreadWithComments {
    return {
      thread: isSet(object.thread) ? CommentThread.fromJSON(object.thread) : undefined,
      comments: globalThis.Array.isArray(object?.comments) ? object.comments.map((e: any) => Comment.fromJSON(e)) : [],
    };
  },

  toJSON(message: ThreadWithComments): unknown {
    const obj: any = {};
    if (message.thread !== undefined) {
      obj.thread = CommentThread.toJSON(message.thread);
    }
    if (message.comments?.length) {
      obj.comments = message.comments.map((e) => Comment.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<ThreadWithComments>): ThreadWithComments {
    return ThreadWithComments.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<ThreadWithComments>): ThreadWithComments {
    const message = createBaseThreadWithComments();
    message.thread = (object.thread !== undefined && object.thread !== null)
      ? CommentThread.fromPartial(object.thread)
      : undefined;
    message.comments = object.comments?.map((e) => Comment.fromPartial(e)) || [];
    return message;
  },
};

function createBaseRepoResearchComment(): RepoResearchComment {
  return { id: "", meta: undefined, repoId: "", area: undefined, comment: undefined };
}

export const RepoResearchComment: MessageFns<RepoResearchComment> = {
  encode(message: RepoResearchComment, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.id !== "") {
      writer.uint32(10).string(message.id);
    }
    if (message.meta !== undefined) {
      EntityMeta.encode(message.meta, writer.uint32(18).fork()).join();
    }
    if (message.repoId !== "") {
      writer.uint32(26).string(message.repoId);
    }
    if (message.area !== undefined) {
      writer.uint32(34).string(message.area);
    }
    if (message.comment !== undefined) {
      InlineComment.encode(message.comment, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RepoResearchComment {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRepoResearchComment();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.id = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.meta = EntityMeta.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.repoId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.area = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.comment = InlineComment.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RepoResearchComment {
    return {
      id: isSet(object.id) ? globalThis.String(object.id) : "",
      meta: isSet(object.meta) ? EntityMeta.fromJSON(object.meta) : undefined,
      repoId: isSet(object.repoId)
        ? globalThis.String(object.repoId)
        : isSet(object.repo_id)
        ? globalThis.String(object.repo_id)
        : "",
      area: isSet(object.area) ? globalThis.String(object.area) : undefined,
      comment: isSet(object.comment) ? InlineComment.fromJSON(object.comment) : undefined,
    };
  },

  toJSON(message: RepoResearchComment): unknown {
    const obj: any = {};
    if (message.id !== "") {
      obj.id = message.id;
    }
    if (message.meta !== undefined) {
      obj.meta = EntityMeta.toJSON(message.meta);
    }
    if (message.repoId !== "") {
      obj.repoId = message.repoId;
    }
    if (message.area !== undefined) {
      obj.area = message.area;
    }
    if (message.comment !== undefined) {
      obj.comment = InlineComment.toJSON(message.comment);
    }
    return obj;
  },

  create(base?: DeepPartial<RepoResearchComment>): RepoResearchComment {
    return RepoResearchComment.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RepoResearchComment>): RepoResearchComment {
    const message = createBaseRepoResearchComment();
    message.id = object.id ?? "";
    message.meta = (object.meta !== undefined && object.meta !== null)
      ? EntityMeta.fromPartial(object.meta)
      : undefined;
    message.repoId = object.repoId ?? "";
    message.area = object.area ?? undefined;
    message.comment = (object.comment !== undefined && object.comment !== null)
      ? InlineComment.fromPartial(object.comment)
      : undefined;
    return message;
  },
};

function createBaseRepoResearchCommentsGroupedCounts(): RepoResearchCommentsGroupedCounts {
  return { countsByArea: {} };
}

export const RepoResearchCommentsGroupedCounts: MessageFns<RepoResearchCommentsGroupedCounts> = {
  encode(message: RepoResearchCommentsGroupedCounts, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.countsByArea).forEach(([key, value]: [string, number]) => {
      RepoResearchCommentsGroupedCounts_CountsByAreaEntry.encode({ key: key as any, value }, writer.uint32(10).fork())
        .join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RepoResearchCommentsGroupedCounts {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRepoResearchCommentsGroupedCounts();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = RepoResearchCommentsGroupedCounts_CountsByAreaEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.countsByArea[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RepoResearchCommentsGroupedCounts {
    return {
      countsByArea: isObject(object.countsByArea)
        ? (globalThis.Object.entries(object.countsByArea) as [string, any][]).reduce(
          (acc: { [key: string]: number }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Number(value);
            return acc;
          },
          {},
        )
        : isObject(object.counts_by_area)
        ? (globalThis.Object.entries(object.counts_by_area) as [string, any][]).reduce(
          (acc: { [key: string]: number }, [key, value]: [string, any]) => {
            acc[key] = globalThis.Number(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: RepoResearchCommentsGroupedCounts): unknown {
    const obj: any = {};
    if (message.countsByArea) {
      const entries = globalThis.Object.entries(message.countsByArea) as [string, number][];
      if (entries.length > 0) {
        obj.countsByArea = {};
        entries.forEach(([k, v]) => {
          obj.countsByArea[k] = Math.round(v);
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<RepoResearchCommentsGroupedCounts>): RepoResearchCommentsGroupedCounts {
    return RepoResearchCommentsGroupedCounts.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RepoResearchCommentsGroupedCounts>): RepoResearchCommentsGroupedCounts {
    const message = createBaseRepoResearchCommentsGroupedCounts();
    message.countsByArea = (globalThis.Object.entries(object.countsByArea ?? {}) as [string, number][]).reduce(
      (acc: { [key: string]: number }, [key, value]: [string, number]) => {
        if (value !== undefined) {
          acc[key] = globalThis.Number(value);
        }
        return acc;
      },
      {},
    );
    return message;
  },
};

function createBaseRepoResearchCommentsGroupedCounts_CountsByAreaEntry(): RepoResearchCommentsGroupedCounts_CountsByAreaEntry {
  return { key: "", value: 0 };
}

export const RepoResearchCommentsGroupedCounts_CountsByAreaEntry: MessageFns<
  RepoResearchCommentsGroupedCounts_CountsByAreaEntry
> = {
  encode(
    message: RepoResearchCommentsGroupedCounts_CountsByAreaEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== 0) {
      writer.uint32(16).int32(message.value);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RepoResearchCommentsGroupedCounts_CountsByAreaEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRepoResearchCommentsGroupedCounts_CountsByAreaEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 16) {
            break;
          }

          message.value = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RepoResearchCommentsGroupedCounts_CountsByAreaEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? globalThis.Number(object.value) : 0,
    };
  },

  toJSON(message: RepoResearchCommentsGroupedCounts_CountsByAreaEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== 0) {
      obj.value = Math.round(message.value);
    }
    return obj;
  },

  create(
    base?: DeepPartial<RepoResearchCommentsGroupedCounts_CountsByAreaEntry>,
  ): RepoResearchCommentsGroupedCounts_CountsByAreaEntry {
    return RepoResearchCommentsGroupedCounts_CountsByAreaEntry.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<RepoResearchCommentsGroupedCounts_CountsByAreaEntry>,
  ): RepoResearchCommentsGroupedCounts_CountsByAreaEntry {
    const message = createBaseRepoResearchCommentsGroupedCounts_CountsByAreaEntry();
    message.key = object.key ?? "";
    message.value = object.value ?? 0;
    return message;
  },
};

function createBaseRepoResearchCommentsByArea(): RepoResearchCommentsByArea {
  return { commentsByArea: {} };
}

export const RepoResearchCommentsByArea: MessageFns<RepoResearchCommentsByArea> = {
  encode(message: RepoResearchCommentsByArea, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.commentsByArea).forEach(([key, value]: [string, RepoResearchCommentList]) => {
      RepoResearchCommentsByArea_CommentsByAreaEntry.encode({ key: key as any, value }, writer.uint32(10).fork())
        .join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RepoResearchCommentsByArea {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRepoResearchCommentsByArea();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = RepoResearchCommentsByArea_CommentsByAreaEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.commentsByArea[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RepoResearchCommentsByArea {
    return {
      commentsByArea: isObject(object.commentsByArea)
        ? (globalThis.Object.entries(object.commentsByArea) as [string, any][]).reduce(
          (acc: { [key: string]: RepoResearchCommentList }, [key, value]: [string, any]) => {
            acc[key] = RepoResearchCommentList.fromJSON(value);
            return acc;
          },
          {},
        )
        : isObject(object.comments_by_area)
        ? (globalThis.Object.entries(object.comments_by_area) as [string, any][]).reduce(
          (acc: { [key: string]: RepoResearchCommentList }, [key, value]: [string, any]) => {
            acc[key] = RepoResearchCommentList.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: RepoResearchCommentsByArea): unknown {
    const obj: any = {};
    if (message.commentsByArea) {
      const entries = globalThis.Object.entries(message.commentsByArea) as [string, RepoResearchCommentList][];
      if (entries.length > 0) {
        obj.commentsByArea = {};
        entries.forEach(([k, v]) => {
          obj.commentsByArea[k] = RepoResearchCommentList.toJSON(v);
        });
      }
    }
    return obj;
  },

  create(base?: DeepPartial<RepoResearchCommentsByArea>): RepoResearchCommentsByArea {
    return RepoResearchCommentsByArea.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RepoResearchCommentsByArea>): RepoResearchCommentsByArea {
    const message = createBaseRepoResearchCommentsByArea();
    message.commentsByArea =
      (globalThis.Object.entries(object.commentsByArea ?? {}) as [string, RepoResearchCommentList][]).reduce(
        (acc: { [key: string]: RepoResearchCommentList }, [key, value]: [string, RepoResearchCommentList]) => {
          if (value !== undefined) {
            acc[key] = RepoResearchCommentList.fromPartial(value);
          }
          return acc;
        },
        {},
      );
    return message;
  },
};

function createBaseRepoResearchCommentsByArea_CommentsByAreaEntry(): RepoResearchCommentsByArea_CommentsByAreaEntry {
  return { key: "", value: undefined };
}

export const RepoResearchCommentsByArea_CommentsByAreaEntry: MessageFns<
  RepoResearchCommentsByArea_CommentsByAreaEntry
> = {
  encode(
    message: RepoResearchCommentsByArea_CommentsByAreaEntry,
    writer: BinaryWriter = new BinaryWriter(),
  ): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      RepoResearchCommentList.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RepoResearchCommentsByArea_CommentsByAreaEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRepoResearchCommentsByArea_CommentsByAreaEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = RepoResearchCommentList.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RepoResearchCommentsByArea_CommentsByAreaEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? RepoResearchCommentList.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: RepoResearchCommentsByArea_CommentsByAreaEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = RepoResearchCommentList.toJSON(message.value);
    }
    return obj;
  },

  create(
    base?: DeepPartial<RepoResearchCommentsByArea_CommentsByAreaEntry>,
  ): RepoResearchCommentsByArea_CommentsByAreaEntry {
    return RepoResearchCommentsByArea_CommentsByAreaEntry.fromPartial(base ?? {});
  },
  fromPartial(
    object: DeepPartial<RepoResearchCommentsByArea_CommentsByAreaEntry>,
  ): RepoResearchCommentsByArea_CommentsByAreaEntry {
    const message = createBaseRepoResearchCommentsByArea_CommentsByAreaEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? RepoResearchCommentList.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseRepoResearchCommentList(): RepoResearchCommentList {
  return { comments: [] };
}

export const RepoResearchCommentList: MessageFns<RepoResearchCommentList> = {
  encode(message: RepoResearchCommentList, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.comments) {
      RepoResearchComment.encode(v!, writer.uint32(10).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RepoResearchCommentList {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRepoResearchCommentList();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.comments.push(RepoResearchComment.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RepoResearchCommentList {
    return {
      comments: globalThis.Array.isArray(object?.comments)
        ? object.comments.map((e: any) => RepoResearchComment.fromJSON(e))
        : [],
    };
  },

  toJSON(message: RepoResearchCommentList): unknown {
    const obj: any = {};
    if (message.comments?.length) {
      obj.comments = message.comments.map((e) => RepoResearchComment.toJSON(e));
    }
    return obj;
  },

  create(base?: DeepPartial<RepoResearchCommentList>): RepoResearchCommentList {
    return RepoResearchCommentList.fromPartial(base ?? {});
  },
  fromPartial(object: DeepPartial<RepoResearchCommentList>): RepoResearchCommentList {
    const message = createBaseRepoResearchCommentList();
    message.comments = object.comments?.map((e) => RepoResearchComment.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string; value: unknown } ? { $case: T["$case"]; value?: DeepPartial<T["value"]> }
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create(base?: DeepPartial<T>): T;
  fromPartial(object: DeepPartial<T>): T;
}
